import { ScrollText } from "lucide-react";

export function LogsPage() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center gap-3 px-6 py-24 text-center">
      <ScrollText className="size-10 text-muted-foreground" />
      <h1 className="text-2xl font-bold">Logs · coming soon</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        One filterable feed for webhook deliveries, API calls and audit events. Click any row to inspect request and response.
      </p>
    </div>
  );
}
